import { render, staticRenderFns } from "./gc-label-printing-grid.vue?vue&type=template&id=152ac796"
import script from "./gc-label-printing-grid.vue?vue&type=script&lang=js"
export * from "./gc-label-printing-grid.vue?vue&type=script&lang=js"
import style0 from "./gc-label-printing-grid.vue?vue&type=style&index=0&id=152ac796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports